"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GOOGLE_CRAWLER_UA_MATCH = exports.EGoogleCrawlerVariant = exports.ECrawlerBrand = void 0;
var ECrawlerBrand;
(function (ECrawlerBrand) {
    ECrawlerBrand["Google"] = "Google";
    ECrawlerBrand["Facebook"] = "Facebook";
})(ECrawlerBrand || (exports.ECrawlerBrand = ECrawlerBrand = {}));
/**
 * @see https://developers.google.com/search/docs/crawling-indexing/google-common-crawlers
 * @see https://developers.google.com/search/docs/crawling-indexing/google-special-case-crawlers
 * @see https://developers.google.com/search/docs/crawling-indexing/google-user-triggered-fetchers
 *
 */
var EGoogleCrawlerVariant;
(function (EGoogleCrawlerVariant) {
    EGoogleCrawlerVariant["GoogleBot$Mobile"] = "googlebot(mobile)";
    EGoogleCrawlerVariant["GoogleBot"] = "googlebot";
    EGoogleCrawlerVariant["Image"] = "image";
    EGoogleCrawlerVariant["Video"] = "video";
    EGoogleCrawlerVariant["News"] = "news";
    EGoogleCrawlerVariant["Storebot"] = "store_bot";
    EGoogleCrawlerVariant["InspectionTool"] = "inspection_tool";
    EGoogleCrawlerVariant["Other"] = "other";
    EGoogleCrawlerVariant["OtherImage"] = "other_image";
    EGoogleCrawlerVariant["OtherVideo"] = "other_video";
    EGoogleCrawlerVariant["CloudVertex"] = "cloud_vertex";
    EGoogleCrawlerVariant["Extended"] = "extended";
    EGoogleCrawlerVariant["APIs"] = "apis";
    EGoogleCrawlerVariant["Ads$Mobile"] = "ads(mobile)";
    EGoogleCrawlerVariant["Ads"] = "ads";
    EGoogleCrawlerVariant["AdSense"] = "ad_sense";
    EGoogleCrawlerVariant["Safety"] = "safety";
    EGoogleCrawlerVariant["FeedFetcher"] = "feed_fetcher";
    EGoogleCrawlerVariant["Producer"] = "producer";
    EGoogleCrawlerVariant["ReadAloud"] = "read_aloud";
    EGoogleCrawlerVariant["SiteVerification"] = "site_verification";
    EGoogleCrawlerVariant["Unknown"] = "unknown";
})(EGoogleCrawlerVariant || (exports.EGoogleCrawlerVariant = EGoogleCrawlerVariant = {}));
exports.GOOGLE_CRAWLER_UA_MATCH = [
    {
        result: EGoogleCrawlerVariant.Image,
        matches: ['Googlebot-Image'],
    },
    {
        result: EGoogleCrawlerVariant.Video,
        matches: ['Googlebot-Video'],
    },
    {
        result: EGoogleCrawlerVariant.News,
        matches: ['Googlebot-News'],
    },
    {
        result: EGoogleCrawlerVariant.GoogleBot$Mobile,
        matches: ['Googlebot', 'Mobile'],
    },
    {
        result: EGoogleCrawlerVariant.GoogleBot,
        matches: ['Googlebot'],
    },
    {
        result: EGoogleCrawlerVariant.Storebot,
        matches: ['Storebot-Google'],
    },
    {
        result: EGoogleCrawlerVariant.InspectionTool,
        matches: ['Google-InspectionTool'],
    },
    {
        result: EGoogleCrawlerVariant.Other,
        matches: ['GoogleOther'],
    },
    {
        result: EGoogleCrawlerVariant.OtherImage,
        matches: ['GoogleOther-Image'],
    },
    {
        result: EGoogleCrawlerVariant.OtherVideo,
        matches: ['GoogleOther-Video'],
    },
    {
        result: EGoogleCrawlerVariant.CloudVertex,
        matches: ['Google-CloudVertexBot'],
    },
    {
        result: EGoogleCrawlerVariant.Extended,
        matches: ['Google-Extended'],
    },
    {
        result: EGoogleCrawlerVariant.APIs,
        matches: ['APIs-Google'],
    },
    {
        result: EGoogleCrawlerVariant.Ads$Mobile,
        matches: ['AdsBot-Google-Mobile'],
    },
    {
        result: EGoogleCrawlerVariant.Ads,
        matches: ['AdsBot-Google'],
    },
    {
        result: EGoogleCrawlerVariant.AdSense,
        matches: ['Mediapartners-Google'],
    },
    {
        result: EGoogleCrawlerVariant.Safety,
        matches: ['Google-Safety'],
    },
    {
        result: EGoogleCrawlerVariant.FeedFetcher,
        matches: ['FeedFetcher-Google'],
    },
    {
        result: EGoogleCrawlerVariant.Producer,
        matches: ['GoogleProducer'],
    },
    {
        result: EGoogleCrawlerVariant.ReadAloud,
        matches: ['Google-Read-Aloud'],
    },
    {
        result: EGoogleCrawlerVariant.SiteVerification,
        matches: ['Google-Site-Verification'],
    },
];
